
export default {
  provide () {
    return {
      inList: true
    };
  },
  props: {
    autoFocus: {
      type: Boolean,
      default: false
    },

    compact: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    listItems () {
      return this.findListItems(this, []);
    }
  },

  mounted () {
    if (this.autoFocus) { this.focus(); }
  },

  methods: {
    findListItems () {
      return [...this.$el.querySelectorAll('.list-item')];
    },

    /**
     * @public
     */
    selectNext (node) {
      const index = this.findListItems().indexOf(node);
      const next = this.listItems[index + 1];

      if (next) { next.focus(); }
    },

    /**
     * @public
     */
    selectPrevious (node) {
      const index = this.findListItems().indexOf(node);
      const previous = this.listItems[index - 1];

      if (previous) { previous.focus(); }
    },

    focus () {
      this.$el.querySelector('.list-item[tabindex]')?.focus();
    }
  }
};
